import React, { Component } from "react";
import {
    Row,
    Col
} from 'reactstrap';

import Registry from "../../Utils/Registry";
import OperationFleetList from "./Fleet/FleetList";
import WavyWaterIndicator from "../WavyWaterIndicator";


class OperationsFleet extends Component{
    constructor(props){
        super(props);
        this.state = {
            gas_list: []
        };
        this.api = Registry.registered("api");
    }

    componentDidMount(){
        this.loadGasList();
    }

    loadGasList = () => {
        this.api.get("/gas?available_to=B2B")
            .then(list => {
                this.setState({
                    gas_list: list.gas
                });
            })
            .catch(error => {});
    };

    render(){
        return (
            <div>
                <Row>
                    <Col xs="12" sm="12" lg="6">
                        <OperationFleetList gas_list={this.state.gas_list} />
                    </Col>
                    { /*<Col>
						<WavyWaterIndicator />
                    </Col> */ }
                </Row>
            </div>
        );
    }
}

OperationsFleet.defaultProps = {

};

export default OperationsFleet;



// WEBPACK FOOTER //
// ./src/components/Operations/Fleet.js